import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import {
  LayoutDashboard, BookOpen, DoorOpen, Clock, Calendar,
  ClipboardList, GraduationCap, Users, ChevronRight
} from 'lucide-react';

const navItems = [
  { to: '/dashboard',       label: 'Dashboard',       icon: LayoutDashboard },
  { to: '/academic-years',  label: 'Academic Years',  icon: GraduationCap },
  { to: '/courses',         label: 'Courses',         icon: BookOpen },
  { to: '/rooms',           label: 'Rooms & Venues',  icon: DoorOpen },
  { to: '/time-slots',      label: 'Time Slots',      icon: Clock },
  { to: '/class-timetable', label: 'Class Timetable', icon: Calendar },
  { to: '/exam-timetable',  label: 'Exam Timetable',  icon: ClipboardList },
  { to: '/students',        label: 'Students',        icon: Users },
];

export default function Sidebar() {
  return (
    <aside className="w-56 bg-[#F7F6F2] border-r border-[#E2E0D8] flex flex-col h-screen sticky top-0">
      {/* Logo */}
      <div className="p-5 border-b border-[#E2E0D8]">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img
            src="/unilia_logo.png"
            alt="Unilia Logo"
            style={{ height: 30, width: 'auto' }}
          />
          <span
            style={{
              fontWeight: 800,
              fontSize: '1.15rem',
              letterSpacing: '-0.03em',
              color: '#003366'
            }}
          >
            MyTimetable
          </span>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 p-3 flex flex-col gap-0.5 overflow-y-auto">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-[13px] transition-colors
               ${isActive
                ? 'bg-[#1a1a18] text-[#F7F6F2] font-medium'
                : 'text-[#5F5E5A] hover:text-[#1a1a18] hover:bg-[#EEEDDB]'}`
            }
          >
            {({ isActive }) => (
              <>
                <Icon className="w-3.5 h-3.5 flex-shrink-0" />
                <span className="flex-1">{label}</span>
                {isActive && <ChevronRight className="w-3 h-3 opacity-60" />}
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}